class DefaultPage {
  static instance;
  static init() {}

  _startup() {}
}

export default DefaultPage;
